<template>
  <div id="shappRegister">
    <el-row>
      <el-col :span="24" class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>上海停车G1G2注册</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true" class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::">
              <el-select v-model="selCustID" filterable clearable placeholder="请选择客户" @change="setPark($event, 0)">
                <el-option v-for="item in choiceCusts" :key="item.fCustID" :label="item.unionName" :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户端ID::">
              <el-input placeholder="请输入客户端ID" v-model="searchKeyWord">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" :disabled="isDisabled"
                @click="bindQuery">查询</el-button>
            </el-form-item>
            <el-form-item style="float:right;margin-right:0px;">
              <el-button type="primary" size="small" @click="addNotifyPathUrl">注册路径</el-button>
              <el-button type="primary" size="small" @click="addSwitchPoints">注册切换点</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24" style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="chnlList" border v-loading="loading" highlight-current-row style="width: 100%"
        :height="tableHeight" ref="singleTable">
        <el-table-column type="index" width="50" :index="indexMethod" label="序号">
        </el-table-column>
        <el-table-column prop="fOpLastTime" width="150" label="最后同步时间">
        </el-table-column>
        <el-table-column prop="fCustNo" width="90px" label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName" width="105" label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkName" width="105" label="场库名称">
        </el-table-column>
        <el-table-column prop="fAppId" width="90px" label="注册Id">
        </el-table-column>
        <el-table-column prop="fPlatformId" width="115px" label="客户端ID">
        </el-table-column>
        <el-table-column prop="fUrlType" width="90px" label="类型">
          <!-- <template slot-scope="scope">{{ getName(scope.row.fUrlType) }}</template> -->
        </el-table-column>
        <el-table-column prop="fH5Url" width="90px" label="H5路径">
        </el-table-column>
        <el-table-column prop="fNodeId" width="90px" label="切换点">
        </el-table-column>
        <el-table-column prop="fLongitude" width="90px" label="经度">
        </el-table-column>
        <el-table-column prop="fLatitude" width="90px" label="纬度">
        </el-table-column>
        <el-table-column prop="fRemark" width="140px" label="备注">
        </el-table-column>
        <el-table-column prop="fAppKey" v-if="false" width="90px" label="注册key">
        </el-table-column>
        <el-table-column prop="fAppKey" v-if="false" width="90px" label="注册key">
        </el-table-column>
        <el-table-column prop="fServerIp" v-if="false" width="90px" label="服务器IP">
        </el-table-column>
        <el-table-column prop="fServerPort" v-if="false" width="90px" label="服务器端口">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="160">
          <template slot-scope="scope">
            <el-button @click="viewChannel(scope.row)" type="success" size="mini">查看</el-button>
            <el-button size="mini" type="warning" v-if="is_edit"
              @click="editChannel(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background @size-change="handleSizeChange" :current-page.sync="pageNo"
            @current-change="handlePage" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes, prev, pager, next, jumper" :total="total" v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="myChnlEditOrDetail">
      <el-dialog :title="detailTitle" v-dialogDrag :visible.sync="isShowH5" class="channelDialog" top="20vh" left="0vh"
        width="50%">
        <el-form :model="curRowInfo" :rules="groupRules" ref="parkRegisterForm" label-width="115px">
          <legend style="padding-top: 10px">
            上海停车平台基础信息
          </legend>
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="客户名称::" prop="fCustID">
                <el-select v-model="curRowInfo.fCustID" filterable placeholder="请选择客户"
                  :disabled="!curRowInfo.isEdit || !curRowInfo.edit" class="myChnlInput" style="width: 100%"
                  @change="setPark($event, 1)">
                  <el-option v-for="item in choiceCusts" :key="item.fCustID" :label="item.unionName"
                    :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="场库名称::" prop="fParkID">
                <el-select v-model="curRowInfo.fParkID" filterable placeholder="请选择场库"
                  :disabled="!curRowInfo.isEdit || !curRowInfo.edit" class="myChnlInput" style="width: 100%">
                  <el-option v-for="item in parks" :key="item.fParkID" :label="item.fParkName" :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="注册AppId::" prop="fAppId">
                <el-input v-model="curRowInfo.fAppId" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="注册key::" prop="fAppKey">
                <el-input v-model="curRowInfo.fAppKey" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户端ID::" prop="fPlatformId">
                <el-input v-model="curRowInfo.fPlatformId" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-form-item label="服务器IP::" prop="fServerIp">
                <el-input v-model="curRowInfo.fServerIp" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务器端口::" prop="fServerPort">
                <el-input v-model="curRowInfo.fServerPort" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <legend style="padding-top: 10px">
            H5路径通知注册
          </legend>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-form-item label="H5路径::" prop="fH5Url">
                <el-input v-model="curRowInfo.fH5Url" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="经度::" prop="fLongitude">
                <el-input v-model="curRowInfo.fLongitude" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="纬度::" prop="fLatitude">
                <el-input v-model="curRowInfo.fLatitude" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="24">
              <el-form-item label="注册结果::">
                <el-input v-model="curRowInfo.fRemark" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="">
                <el-button type="primary" @click="initAd">便捷寻车注册(G1)</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <el-button type="primary" @click="initAd">泊位引导注册(G2)</el-button>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('parkRegisterForm', 7)" v-if="curRowInfo.isEdit"
            :loading="save_loading">便捷寻车注册(G1)</el-button>
          <el-button type="primary" @click="submitForm('parkRegisterForm', 5)" v-if="curRowInfo.isEdit"
            :loading="save_loading">泊位引导注册(G2)</el-button>
          <el-button @click="isShowH5 = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="myChnlEditOrDetail">
      <el-dialog :title="detailTitle" v-dialogDrag :visible.sync="isShowSP" class="channelDialog" top="20vh" left="0vh"
        width="50%">
        <el-form :model="curRowInfo" :rules="groupRules" ref="parkRegSwitchPointsForm" label-width="115px">
          <legend style="padding-top: 10px">
            上海停车平台基础信息
          </legend>
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="客户名称::" prop="fCustID">
                <el-select v-model="curRowInfo.fCustID" filterable placeholder="请选择客户"
                  :disabled="!curRowInfo.isEdit || !curRowInfo.edit" class="myChnlInput" style="width: 100%"
                  @change="setPark($event, 1)">
                  <el-option v-for="item in choiceCusts" :key="item.fCustID" :label="item.unionName"
                    :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="场库名称::" prop="fParkID">
                <el-select v-model="curRowInfo.fParkID" filterable placeholder="请选择场库"
                  :disabled="!curRowInfo.isEdit || !curRowInfo.edit" class="myChnlInput" style="width: 100%">
                  <el-option v-for="item in parks" :key="item.fParkID" :label="item.fParkName" :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="注册AppId::" prop="fAppId">
                <el-input v-model="curRowInfo.fAppId" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="注册key::" prop="fAppKey">
                <el-input v-model="curRowInfo.fAppKey" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户端ID::" prop="fPlatformId">
                <el-input v-model="curRowInfo.fPlatformId" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-form-item label="服务器IP::" prop="fServerIp">
                <el-input v-model="curRowInfo.fServerIp" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务器端口::" prop="fServerPort">
                <el-input v-model="curRowInfo.fServerPort" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <legend style="padding-top: 10px">
            切换点注册
          </legend>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px"> <el-col :span="8">
              <el-form-item label="切换点::" prop="fNodeId">
                <el-input v-model="curRowInfo.fNodeId" style="width:100%"
                  disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经度::" prop="fLongitude">
                <el-input v-model="curRowInfo.fLongitude" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="纬度::" prop="fLatitude">
                <el-input v-model="curRowInfo.fLatitude" style="width:100%" :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="24">
              <el-form-item label="注册结果::">
                <el-input v-model="curRowInfo.fRemark" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('parkRegSwitchPointsForm', 100)" v-if="curRowInfo.isEdit"
            :loading="save_loading">注册切换点</el-button>
          <el-button @click="isShowSP = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'parkingGeoMain.vue',
  data () {
    return {
      isDisabled: false,
      loading: false,
      is_edit: false,
      is_del: false,
      is_export: false,
      is_import: false,
      export_loading: false,
      save_loading: false,
      selCustID: '',
      choiceCusts: [],
      curRowInfo: {
        fBigRowID: 0,
        edit: false,
        isEdit: false,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fAppId: '',
        fAppKey: '',
        fServerIp: 'https://parkzhtc.jtcx.sh.cn',
        fServerPort: '443',
        fPlatformId: '',
        fH5Url: '',
        fUrlType: '',
        fNodeId: '',
        fLongitude: '',
        fLatitude: '',
        fRemark: ''
      },
      groupRules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fAppId: [
          { required: true, message: '请输入注册AppId', trigger: 'change' }
        ],
        fAppKey: [
          { required: true, message: '请输入注册Key', trigger: 'change' }
        ],
        fServerIp: [
          { required: true, message: '请输入服务器IP', trigger: 'change' }
        ],
        fServerPort: [
          { required: true, message: '请输入服务器端口', trigger: 'change' }
        ],
        fPlatformId: [
          { required: true, message: '请输入客户端ID', trigger: 'change' }
        ]
      },
      isShowH5: false,
      isShowSP: false,
      detailTitle: '查看通道信息',
      choiceParks: [],
      parks: [],
      selfParkID: '',
      searchKeyWord: '',
      chnlList: [],
      tableHeight: 200,
      form: {

      },
      pageSize: 20,
      pageNo: 1,
      total: 0,
      importDataVisible: false,
      download_loading: false,
      importModel: {
        fCustID: '',
        data: [],
        loading: false,
        btnMsg: '点击上传',
        btnLoading: false,
        btnOkDisabled: true,
        btnOkMsg: '确定导入',
        btnOkLoading: false
      }
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    ...mapActions([
      'getParkList', 'getShappRegisterList', 'getCustByGroup', 'saveShappRegister', 'getCurrentUserPers'
    ]),
    /* eslint-disable*/
    //此行往下都不检查Eslint
    submitForm (formName, urlType) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.curRowInfo.fUrlType = urlType
          this.saveShappRegister(this.curRowInfo).then(res => {
            this.save_loading = false
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.isShowH5 = false
                this.isShowSP = false
                this.initData()
                this.$message.success(data.Msg)
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    getName (fUrlType) {
      return fUrlType == 7 ? '便捷寻车' : fUrlType == 5 ? '泊位引导' : '切换点'
    },
    addNotifyPathUrl () {
      setTimeout(() => {
        if (this.$refs['parkRegisterForm']) {
          this.$refs['parkRegisterForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '新增场库G1G2通知路径注册'
      this.isShowH5 = true
      this.curRowInfo = {
        fBigRowID: 0,
        edit: true,
        isEdit: true,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fAppId: '',
        fAppKey: '',
        fServerIp: 'https://parkzhtc.jtcx.sh.cn',
        fServerPort: '443',
        fPlatformId: '',
        fH5Url: '',
        fUrlType: '',
        fNodeId: '',
        fLongitude: '',
        fLatitude: '',
        fRemark: ''
      }
    },
    addSwitchPoints () {
      setTimeout(() => {
        if (this.$refs['parkRegSwitchPointsForm']) {
          this.$refs['parkRegSwitchPointsForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '新增场库G1G2切换点注册'
      this.isShowSP = true
      this.curRowInfo = {
        fBigRowID: 0,
        edit: true,
        isEdit: true,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fAppId: '',
        fAppKey: '',
        fServerIp: 'https://parkzhtc.jtcx.sh.cn',
        fServerPort: '443',
        fPlatformId: '',
        fH5Url: '',
        fUrlType: '',
        fNodeId: new Date().getTime(),
        fLongitude: '',
        fLatitude: '',
        fRemark: ''
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      this.isDisabled = true
      let chnlParam = {}
      chnlParam['fCustID'] = this.selCustID
      chnlParam['searchKeyWord'] = this.searchKeyWord
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 0
      this.loading = true

      this.getShappRegisterList(chnlParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // let tmpChnl = []
              // Object.assign(tmpChnl, data.Data.rows)
              this.chnlList = data.Data.data || []
              this.total = data.Data.count
            }
          }
        }
        this.isDisabled = false
      })
    },
    editChannel (index, row) {
      this.detailTitle = '编辑【' + row.fCustName + '】'
      this.isShowH5 = false
      this.isShowSP = false
      //if (row.fUrlType == "100") {
      if (row.fUrlType == "切换点") {
        setTimeout(() => {
          if (this.$refs['parkRegSwitchPointsForm']) {
            this.$refs['parkRegSwitchPointsForm'].clearValidate()
          }
        }, 50)
        this.isShowSP = true
      } else {
        setTimeout(() => {
          if (this.$refs['parkRegisterForm']) {
            this.$refs['parkRegisterForm'].clearValidate()
          }
        }, 50)
        this.isShowH5 = true
      }
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data
            }
          }
        }
      })
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = true
      this.curRowInfo.edit = false
      this.setPark(row.fCustID, 0, row.fParkID)
    },
    viewChannel (row) {
      this.isShowH5 = false
      this.isShowSP = false
      if (row.fUrlType == "100") {
        setTimeout(() => {
          if (this.$refs['parkRegSwitchPointsForm']) {
            this.$refs['parkRegSwitchPointsForm'].clearValidate()
          }
        }, 50)
        this.isShowSP = true
      } else {
        setTimeout(() => {
          if (this.$refs['parkRegisterForm']) {
            this.$refs['parkRegisterForm'].clearValidate()
          }
        }, 50)
        this.isShowH5 = true
      }
      this.detailTitle = '查看【' + row.fCustName + '】'
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data
            }
          }
        }
      })
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = false
      this.curRowInfo.edit = false
    },
    setPark (val, type, fParkID = '') {
      if (type === 0) {
        this.choiceParks = []
        this.selfParkID = ''
      } else if (type === 1) {
        this.parks = []
        if ((fParkID || '').trim().length <= 0) {
          this.curRowInfo.fParkID = ''
        }
      }
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (type === 0) {
                this.choiceParks = data.Data || []
              } else if (type === 1) {
                this.parks = data.Data || []
              }
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 1199000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit            
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.setPark(this.selCustID, 0)
            }
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
.myChnlEditOrDetail .el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #606266;
}

.myChnlEditOrDetail .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}

.myChnlEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}

.myChnlEditOrDetail .el-dialog__title {
  color: white;
}

.myChnlEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}

.myChnlEditOrDetail .el-dialog__body {
  padding: 5px;
  padding-bottom: 0px;
}

.myChnlEditOrDetail .ledDialog .el-dialog__body {
  padding: 0px;
}

.myChnlEditOrDetail .el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #666666;
  cursor: not-allowed;
  /*font-family: 宋体;*/
  font-size: 13px;
}

.myChnlEditOrDetail .myChnlLableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}

.myChnlEditOrDetail .is-disabled .el-input__inner,
.myChnlEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}

.myChnlEditOrDetail .el-row {
  margin-bottom: 5px;
}

.myChnlEditOrDetail .el-radio {
  line-height: 2px;
}

/* dialog弹出框样式 */
#parkingGeoMain .channelDialog .el-dialog {
  min-width: 910px;
}

#parkingGeoMain .screenDialog .el-dialog {
  min-width: 800px;
}

#parkingGeoMain .voiceDialog .el-dialog {
  min-width: 410px;
}

#parkingGeoMain .warning-row {
  color: chocolate;
}

#parkingGeoMain .error-row {
  color: #fb4545;
}
</style>

<style scoped>
fieldset {
  padding-bottom: 0px;
}

.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}

.pageSearch .el-form-item {
  margin-bottom: 5px;
}

.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}

.myel-input__inner {
  height: 20px;
  line-height: 20px;
}

legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}

fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}

.searchRowAdd {
  text-align: right;
}

.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/park/shappRegister.vue